

<template>
  <div class="login-page">

    <div class="login-card">


      <div class="logo-container fade-in">
          <svg width="150" height="50" viewBox="0 0 400 100" xmlns="http://www.w3.org/2000/svg">
            <!-- Sfondo trasparente -->
            <rect width="400" height="100" fill="transparent"/>
            
            <!-- Icona carrello -->
            <circle cx="40" cy="50" r="20" fill="#224abe"/>
            <line x1="25" y1="50" x2="55" y2="50" stroke="white" stroke-width="4"/>
            
            <!-- Testo -->
            <text x="80" y="60" font-family="Roboto, sans-serif" font-size="36" fill="#224abe">
              STUDIO RETAIL
            </text>
          </svg>
      </div>

      <h2 class="login-title">🔐 Login</h2>


      <!-- ALERT DINAMICO -->
      <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
      </div>


      <form @submit.prevent="submit">

        <div class="form-group floating-label">
          <input v-focus
            type="text"
            v-model="username"
            required
            class="form-control"
          />
          <label>Email</label>
        </div>

        <div class="form-group floating-label password-field">
          <input
            :type="'password'"
            v-model="password"
            required
            class="form-control"
          />
          <label>Password</label>
          <span v-if="false" class="toggle-password" @click="togglePassword">
            {{ showPassword ? '🙈' : '👁' }}
          </span>
        </div>

        <div v-if="false" class="form-check mb-3">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="remember"
            id="remember"
          >
          <label v-if="false" class="form-check-label" for="remember">
            Ricordami
          </label>
        </div>

        <button class="btn login-btn" :disabled="spinner">
          <span v-if="spinner" class="spinner"></span>
          <span v-else>Accedi</span>
        </button>

        <div v-if="false" class="forgot">
          <a href="#">Password dimenticata?</a>
        </div>

      </form>




<div v-if="false" class="google-login-container mt-1">
  <div id="google-button"></div>
</div>



</div>


  </div>
</template>

<script>
import axios              from 'axios';
import alertBox from '@/components/common/AlertBox.vue';
export default {
  components: {alertBox},
   data () {
    return {

      errorMessage : '',
      username     : '',
      password     : '',   
      spinner      : false,
     
     
     
    }
    
    
    },
   watch: {

    },
    directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },
    mounted()
    {
      /*
      this.renderGoogleButton();      
      window.handleCredentialResponse = this.handleCredentialResponse;
      */
      
    },
    created()
    {
        //localStorage.removeItem("deskId")
        localStorage.removeItem('cart')
        localStorage.removeItem('barcode')
        localStorage.removeItem('customer')   

       this.$store.commit('AUTH_STATUS_CHANGE',{isLoggedIn : false}) 
       this.$store.commit('AUTH_STORE_ID',{storeId: 0})
       
    },
    methods:{
      handleCredentialResponse(response) {
        console.log("Google token:", response.credential);
      },
      
      renderGoogleButton() {
      if (!window.google) return;

        window.google.accounts.id.initialize({
          client_id: "891850345831-2tmtr9daqrrrfljbspeh4r2pg6cs2nu2.apps.googleusercontent.com",
          callback: this.handleCredentialResponse
        });

        window.google.accounts.id.renderButton(
          document.getElementById("google-button"),
          {
            theme: "outline",
            size: "large"
          }
        );
    },
      submit()
      {
      
        
        this.spinner  = true  
        
        const url       = process.env.VUE_APP_ROOT_API + "api/sp/login"        
        const data      = {'username' : this.username}
        const sp        = {'sp'       : 'spLogin'}
        const json      = Object.assign(data, sp);
    
        axios({
        url    : url,
        method : "post",
        data   : json
        
        })
        .then(res => {
                    
         
          if(res.data.recordsets[0].length > 0)
          {

            var userId       = res.data.recordsets[0][0].userId
            
            var password     = res.data.recordsets[0][0].password
            var isAdmin      = res.data.recordsets[0][0].isAdmin
            var companyId    = res.data.recordsets[0][0].companyId
            var isLocked     = res.data.recordsets[0][0].isLocked
            var url_img      = res.data.recordsets[0][0].img_url
            var img_num      = res.data.recordsets[0][0].img_num
            var token        = res.data.token
            var printer_type = res.data.recordsets[0][0].printer_type
            var vat          = res.data.recordsets[0][0].vat
            var shopify      = res.data.recordsets[0][0].shopify
            var sync_stock   = res.data.recordsets[0][0].sync_stock

            
           
            if(isLocked == 1)
            {
              this.errorMessage = 'Utente non abilitato.'              
              return
            }
            if(this.password != password)
            {
              this.errorMessage = 'Password non valida.'
              return
            }


          }
          else
          {
              this.errorMessage = 'Utente o password non validi.'
              
              return
          }
          
          const userMenu = res.data.recordsets[1]
          this.$store.commit('SET_COMPANY',{reset:false,Id:companyId,printer_type:printer_type,vat:vat,'shopify':shopify,'sync_stock':sync_stock}) 
          this.$store.commit('SET_COMPANY_URL_IMG',{url:url_img,num:img_num}) 
          this.$store.commit('AUTH_STATUS_CHANGE',{userId:userId, isLoggedIn : true,currentUser : this.username,isAdmin:isAdmin,token:token,userMenu:userMenu}) 
          this.$router.push('/store')

        })
        .catch(err => {
              //console.log(err)
              
              if(err.response)
              {
              
                this.errorMessage = err.response.statusText
                
               
              }
              else 
              {
                this.errorMessage = err
               
              }
              return
        
        
        
        })
        .finally(() => {
          this.spinner = false
         
        });
      }
    },  
 
}

</script>
<style scoped>
.login-page {

  height          : 100vh;
  display         : flex;
  justify-content : center;
  align-items     : center;
  background      : linear-gradient(135deg, #d8dbe3, #224abe);
  /*background      : linear-gradient(135deg, #667eea, #764ba2);*/
  font-family     : 'Roboto', sans-serif;

}

.login-card {

  

  background    : rgba(255, 255, 255, 0.95);
  padding       : 40px;
  width         : 450px;
  border-radius : 12px;
  box-shadow    : 0 12px 30px rgba(0,0,0,0.25);
  position      : relative;

  transform: translateY(-60px);
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  font-weight: 700;
  color: #224abe;
}

.floating-label {
  position: relative;
  margin-bottom: 25px;
}

.floating-label input {
  width: 100%;
  padding: 12px 12px 12px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  transition: all 0.2s;
}

.floating-label label {
  position: absolute;
  top: 12px;
  left: 12px;
  color: #888;
  transition: 0.2s;
  pointer-events: none;
}

.floating-label input:focus + label,
.floating-label input:not(:placeholder-shown) + label {
  top: -10px;
  left: 10px;
  font-size: 12px;
  color: #224abe;
  background: white;
  padding: 0 4px;
}

.password-field {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
}

.login-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  background-color: #224abe;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
}

.login-btn:hover {
  background-color: #4e73df;
}

.login-btn:disabled {
  background-color: #999;
  cursor: not-allowed;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #fff;
  border-top: 3px solid #224abe;
  border-radius: 50%;
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.forgot {
  text-align: center;
  margin-top: 15px;
}

.forgot a {
  font-size: 14px;
  color: #4e73df;
  text-decoration: none;
}

.forgot a:hover {
  text-decoration: underline;
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
}

.logo-container svg {
  width: 250px;   /* nuova larghezza */
  height: auto;   /* mantiene proporzioni */
  max-width: 100%; 
}


.fade-in {
  opacity: 0;
  animation: fadeIn 1s forwards;
  animation-delay: 0.3s; /* puoi regolare il ritardo */
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}


</style>